<ng-container *transloco="let t">
  @if (product?.inStock) {
    @if (!buybackCart()) {
      <a class="button popsy-button-option full-width" (click)="openBuybackPromo()">
        <popsy-icon-trade-arrows class="icon"></popsy-icon-trade-arrows>
        <span class="text">{{
          lang === 'ar'
            ? 'احصل على هذا الجهاز بسعر أقل!'
            : 'Get this device for even less!'
        }}</span>
      </a>
    } @else {
      <div class="button popsy-button-option trade full-width">
        <popsy-icon-trade-arrows class="icon"></popsy-icon-trade-arrows>
        <div class="flex flex-col">
          @if (lang !== 'ar') {
            <strong class="">
              {{ 'Trade-in Credit: ' + (buybackCart()?.price | amount) }}
            </strong>
          } @else {
            <strong class="">
              {{ 'رصيد التجارة: ' + (buybackCart()?.price | amount) }}
            </strong>
          }

          <span class="subtitle">{{ buybackCart()?.bbTitle }}</span>
        </div>
        <div class="flex justify-end">
          <button class="popsy-button-option" (click)="onRemoveBuyBackProduct()">
            @if (lang !== 'ar') {
              DELETE
            } @else {
              حذف
            }
          </button>
        </div>
      </div>
    }
  }
</ng-container>
